import { normalizePropToPropertyMapping, asNumber, asString, asObject, } from "./property";
import { normalizePropToPropertySetterMapping, asPropertySetter, } from "./setter";
import { normalizePropToEventMapping, asEventEmitter, } from "./event";
import { PropMappingType } from "./type";
export { PropMappingType } from "./type";
/**
 * Typeguard for Property mapping
 */
export function isPropToPropertyMapping(x) {
    return x.mappingType === PropMappingType.Property;
}
/**
 * Typeguard for Property mapping with attribute
 */
export function isPropToPropertyMappingWithAttribute(x) {
    return (x.mappingType === PropMappingType.Property && x.attribute !== undefined);
}
/**
 * Typeguard for Event mapping
 */
export function isPropToEventMapping(x) {
    return x.mappingType === PropMappingType.Event;
}
/**
 * Typeguard for Property setter mapping
 */
export function isPropToPropertySetterMapping(x) {
    return x.mappingType === PropMappingType.PropertySetter;
}
export function normalizePropMapping(tagName, propName, propMapping) {
    switch (propMapping.mappingType) {
        case PropMappingType.Property:
            return normalizePropToPropertyMapping(tagName, propName, propMapping);
        case PropMappingType.Event:
            return normalizePropToEventMapping(tagName, propName, propMapping);
        case PropMappingType.PropertySetter:
            return normalizePropToPropertySetterMapping(tagName, propName, propMapping);
    }
}
export function normalizePropsMapping(tagName, propsMapping) {
    return Object.keys(propsMapping).map((k) => {
        const key = k;
        const value = propsMapping[key];
        return normalizePropMapping(tagName, key, value);
    });
}
export const WidgetPropsMapping = {
    asNumber,
    asString,
    asObject,
    asEventEmitter,
    asPropertySetter,
};
